import React, { useState } from 'react';
import './LengthConverter.css';

function LengthConverter() {
  const [value, setValue] = useState(1);
  const [fromUnit, setFromUnit] = useState('meter');
  const [toUnit, setToUnit] = useState('centimeter');

  const units = {
    meter: 1,
    centimeter: 100,
    millimeter: 1000,
    kilometer: 0.001,
    inch: 39.3701,
    foot: 3.28084,
  };

  const handleConvert = () => {
    const valueInMeters = value / units[fromUnit];
    const convertedValue = valueInMeters * units[toUnit];
    return convertedValue.toFixed(4);
  };

  return (
    <div className="length-converter-box">
      <h4 style={{ color: '#c4a716', fontWeight: 'bold' }}>Length Converter</h4>

      <div className="length-converter-row mb-3">
        <input
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <select value={fromUnit} onChange={(e) => setFromUnit(e.target.value)}>
          {Object.keys(units).map((unit) => (
            <option key={unit} value={unit}>{unit}</option>
          ))}
        </select>
        <span className="mx-2 align-self-center">to</span>
        <select value={toUnit} onChange={(e) => setToUnit(e.target.value)}>
          {Object.keys(units).map((unit) => (
            <option key={unit} value={unit}>{unit}</option>
          ))}
        </select>
      </div>
      <h5 style={{ color: '#1bc0bd' }} className="converted-label">
  Converted Value: {handleConvert()}
</h5>


    </div>
  );
}

export default LengthConverter;
